export interface UomOption {
  UomId: string;
  UomName: string;
}

export enum UOM {
  IU = '1',
  CC = '2',
  ML = '3',
  MG = '4',
  MCG = '5',
  LTR = '6',
}

export const UOM_LABELS: Record<UOM, string> = {
  [UOM.IU]: 'IU',
  [UOM.CC]: 'CC',
  [UOM.ML]: 'ML',
  [UOM.MG]: 'MG',
  [UOM.MCG]: 'MCG',
  [UOM.LTR]: 'LTR',
};

export const UOM_FALLBACK_OPTIONS: UomOption[] = Object.entries(UOM_LABELS).map(
  ([UomId, UomName]) => ({
    UomId,
    UomName,
  }),
);
